export default __webpack_public_path__ + "static/media/code-1.1a6a62f5.jpg";